import React, { useState, useEffect } from 'react';
import '../css/Gallery.css';
import asset from '../assets/images';
import { useImageContext } from '../context/ImageContext';

// Use relative path for shared hosting
const API_BASE = process.env.PUBLIC_URL || '';

const filterOptions = ['All', 'Weddings', 'Events', 'Concerts', 'Portraits', 'Pre-Shoots'];

export default function Gallery() {
  const { images, setImages } = useImageContext();
  const [filter, setFilter] = useState('All');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Fetch images from PHP backend
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/get-images.php`);
        const data = await res.json();
        if (Array.isArray(data)) setImages(data);
      } catch (err) {
        console.error('Failed to fetch images', err);
      }
    })();
  }, [setImages]);

  const filtered = filter === 'All'
    ? images
    : images.filter(img => img.folder === filter);

  const openModal = (img, idx) => {
    setSelectedImage(img);
    setSelectedIndex(idx);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
    setSelectedIndex(null);
  };

  const goToNext = () => {
    const next = (selectedIndex + 1) % filtered.length;
    setSelectedImage(filtered[next]);
    setSelectedIndex(next);
  };

  const goToPrev = () => {
    const prev = (selectedIndex - 1 + filtered.length) % filtered.length;
    setSelectedImage(filtered[prev]);
    setSelectedIndex(prev);
  };

  return (
    <div className="gallery-container">
      {/* Banner */}
      <div className="slide first">
        <img src={asset.gallery} alt="Gallery Banner" />
        <div className="carousel-text">
          <h1>Gallery</h1>
        </div>
      </div>

      {/* Filters */}
      <div className="gallery-filters">
        {filterOptions.map(opt => (
          <button
            key={opt}
            className={`filter-btn${filter === opt ? ' active' : ''}`}
            onClick={() => setFilter(opt)}
          >
            {opt}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="gallery-grid">
        {filtered.length === 0
          ? <p>No images found for “{filter}”.</p>
          : filtered.map((img, idx) => (
              <div
                key={idx}
                className="gallery-item"
                onClick={() => openModal(img, idx)}
              >
                <img src={`${API_BASE}${img.url}`} alt={`gallery-${idx}`} />
              </div>
            ))
        }
      </div>

      {/* Modal */}
      {modalOpen && selectedImage && (
        <div className="modal open" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <span className="close" onClick={closeModal}>&times;</span>
            <img
              src={`${API_BASE}${selectedImage.url}`}
              alt="Selected"
              className="modal-image"
            />
            <button className="prev" onClick={goToPrev}>&#10094;</button>
            <button className="next" onClick={goToNext}>&#10095;</button>
          </div>
        </div>
      )}
    </div>
  );
}
